<template>

</template>

<script>

export default {
  data() {
    return {
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      var params = {
        data: this.$route.query.data
      };
      this.$get("/pay/rechargeUppReturn", params).then(response => {
        if (response.code === 0) {
          this.$router.push("/order/pay/"+response.data.id);
        } else {
          this.$router.push("/");
        }
      });
    }
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/pay/RechargePayReturn.vue